// Generated types for NodeMergeTask
// This file is auto-generated - do not edit manually

import { z } from 'zod';

import { LLMTaskReadAPI, LLMTaskWriteAPI } from '../../llm_task/types/llmtask';
import { LLMTaskReadAPISchemaObject, LLMTaskWriteAPISchemaObject } from '../../llm_task/types/llmtask';

// ============================================================================
// TypeScript Interfaces
// ============================================================================

export interface NodeMergeTaskReadAPI extends LLMTaskReadAPI {
}

export interface NodeMergeTaskWriteAPI extends LLMTaskWriteAPI {
}

// ============================================================================
// Zod Schemas
// ============================================================================

export const NodeMergeTaskReadAPISchema: z.ZodType<NodeMergeTaskReadAPI> = LLMTaskReadAPISchemaObject.extend({}).passthrough();

export const NodeMergeTaskWriteAPISchema: z.ZodType<NodeMergeTaskWriteAPI> = LLMTaskWriteAPISchemaObject.extend({}).passthrough();
